import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VCard,[_c(VContainer,{attrs:{"fluid":""}},[_c(VCardText,[_c('display-settings')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }